<div class="container-fluid">
  <div class="list-header">
    <h1>Style Guide Page</h1>
  </div>
  <div class="row">
    <div class="col">
      <section id="typography">
        <h3 class="demo-section-title">Typography</h3>

        <div class="row">
          <div class="col-auto">
            <h1>Heading One (Page Title)</h1>
            <h2>Heading Two</h2>
            <h3>Heading Three (Card Titles)</h3>
            <h4>Heading Four</h4>
            <h5>Heading Five</h5>
            <h6>Heading Six</h6>
          </div>
          <div class="col border-left">
            <div class="row">
              <div class="col-4">
                <h5 class="subtitle text-right">
                  Regular paragraph (with bolded text)
                </h5>
              </div>
              <div class="col">
                <p>
                  Here is a regular paragraph.
                  <strong>Lorem, ipsum dolor</strong>
                  sit amet consectetur adipisicing elit. Porro consectetur,
                  provident officia harum nihil quis sequi esse pariatur illo
                  expedita saepe vero? Nobis repellendus non inventore unde
                  tenetur quia excepturi.
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <h5 class="subtitle text-right">
                  Small text (with bolded text)
                </h5>
              </div>
              <div class="col">
                <small>
                  Here is a regular paragraph
                  <strong>width bold (strong) text</strong>
                  . Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                  Porro consectetur, provident officia harum nihil quis sequi
                  esse pariatur illo expedita saepe vero?
                </small>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="forms">
        <h3 class="demo-section-title">Form elements</h3>
        <h5 class="subtitle">
          Fields with 'outline' appearance look like this:
        </h5>

        <p>
          <mat-form-field appearance="fill">
            <mat-label>Form label here</mat-label>
            <input matInput placeholder="Placeholder" />
            <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
            <mat-hint>Hint will be here</mat-hint>
          </mat-form-field>
        </p>

        <h5 class="subtitle">Basic native select width 'outline' appearance</h5>
        <p>
          <mat-form-field appearance="fill">
            <mat-label>Cars</mat-label>
            <select matNativeControl required>
              <option value="volvo">Volvo</option>
              <option value="saab">Saab</option>
              <option value="mercedes">Mercedes</option>
              <option value="audi">Audi</option>
            </select>
          </mat-form-field>
        </p>

        <h5 class="subtitle">Checkboxes and radios</h5>
        <p>
          <mat-checkbox color="primary">Check me!</mat-checkbox>
        </p>
        <!-- <p>
          <mat-radio-button>Option 1</mat-radio-button>
        </p> -->
      </section>

      <section id="buttons">
        <h3 class="demo-section-title">Buttons</h3>
        <h5 class="subtitle">
          Main buttons with solid colors "mat-flat-button"
        </h5>

        <div class="row small-gutters">
          <div class="col-auto">
            <button mat-flat-button color="primary">Primary button</button>
          </div>
          <!-- <div class="col-auto"><button mat-flat-button color="accent">Accent button</button></div> -->
          <!-- NOTE: Currently not in use -->
          <div class="col-auto">
            <button mat-flat-button color="success">Success button</button>
          </div>
          <div class="col-auto">
            <button mat-flat-button color="warn">Warn button</button>
          </div>
          <div class="col-auto">
            <button mat-flat-button>No color button</button>
          </div>
          <div class="col-auto">
            <button mat-flat-button class="button--more">
              <mat-icon>more_horiz</mat-icon>
            </button>
          </div>
        </div>

        <br />
        <br />

        <h5 class="subtitle">
          Secondary buttons with borders "mat-stroked-button"
        </h5>

        <div class="row small-gutters">
          <div class="col-auto">
            <button mat-stroked-button color="primary">Primary button</button>
          </div>
          <!-- <div class="col-auto"><button mat-stroked-button color="accent">Accent button</button></div> -->
          <!-- NOTE: Currently not in use -->
          <div class="col-auto">
            <button mat-stroked-button color="success">Success button</button>
          </div>
          <div class="col-auto">
            <button mat-stroked-button color="warn">Warn button</button>
          </div>
          <div class="col-auto">
            <button mat-stroked-button>No color button</button>
          </div>
          <div class="col-auto">
            <button mat-stroked-button class="button--more">
              <mat-icon>more_horiz</mat-icon>
            </button>
          </div>
        </div>
      </section>

      <section id="chips">
        <h3 class="demo-section-title">
          (Custom) Chips (for modules and status)
        </h3>

        <mat-chip-listbox>
          <!-- <mat-chip color="primary" selected>Primary fish</mat-chip> -->
          <!-- NOTE: Currently not in use -->
          <!-- <mat-chip color="accent" selected>Accent fish</mat-chip> -->
          <!-- NOTE: Currently not in use -->
          <mat-chip-option color="active">Active status</mat-chip-option>
          <mat-chip-option color="inactive">Inactive status</mat-chip-option>
          <mat-chip-option>neutral (Pending status)</mat-chip-option>
          <!-- <mat-chip color="warn" selected>Success fish</mat-chip> -->
          <!-- NOTE: Currently not in use -->
          <mat-chip-option color="stroked">
            <mat-icon>dashboard</mat-icon>
            Stroked
          </mat-chip-option>
        </mat-chip-listbox>
      </section>
    </div>

    <div class="col-md-auto">
      <div class="position-sticky">
        <h4>Table of contents</h4>
        <a class="d-block py-2" href="/style-guide#typography">Typography</a>
        <a class="d-block py-2" href="/style-guide#forms">Forms</a>
        <a class="d-block py-2" href="/style-guide#buttons">Buttons</a>
        <a class="d-block py-2" href="/style-guide#chips">Chips</a>
      </div>
    </div>
  </div>
</div>
